document.addEventListener("DOMContentLoaded", function () {
  const reports = document.querySelectorAll(".nsr-report3");

  if (!reports.length) {
    return;
  }

  reports.forEach(initReport3);

  function initReport3(report) {
    /* -------------------------------------------------------
       Elements
    ------------------------------------------------------- */

    const tableToggle = report.querySelector(".nsr-report3-table-toggle");
    const tableHost = report.querySelector(".nsr-report3-table-host");

    const volatilityContainer = report.querySelector(".nsr-report3-volatility");

    const scoreElement = report.querySelector(".nsr-report3-score-value");

    const titleElement = report.querySelector(".nsr-report3-main-title");

    const alertText = report.querySelector(".nsr-report3-alert-text");

    const alertBox = report.querySelector(".nsr-report3-alert");

    const selectedContainer = report.querySelector(
      ".nsr-report3-selected-items",
    );

    const searchInput = report.querySelector(".nsr-report3-search-input");

    /* -------------------------------------------------------
       Table toggle
    ------------------------------------------------------- */

    if (tableToggle && tableHost) {
      tableToggle.addEventListener("click", function () {
        const isOpen = tableToggle.getAttribute("aria-expanded") === "true";

        tableToggle.setAttribute("aria-expanded", String(!isOpen));

        tableHost.hidden = isOpen;

        tableToggle.textContent = isOpen
          ? "Visa siffrorna som en tabell"
          : "Göm siffrorna";
      });
    }

    /* -------------------------------------------------------
       State
    ------------------------------------------------------- */

    let currentDays = parseInt(report.dataset.days || "30", 10);

    if (!currentDays || currentDays <= 0) {
      currentDays = 30;
    }

    /*
     * Real multi-select.
     *
     * Multiple volatility series can be selected.
     * Multiple SERP series can be selected.
     *
     * SERP and volatility are never mixed in the
     * same chart.
     */
    let selectedItems = [];

    let currentMainDatasets = [];

    let resizeTimer = null;

    let requestVersion = 0;

    /* -------------------------------------------------------
       Helpers
    ------------------------------------------------------- */

    function escapeHtml(value) {
      const div = document.createElement("div");

      div.textContent =
        value === null || value === undefined ? "" : String(value);

      return div.innerHTML;
    }

    function formatNumber(value) {
      const number = Number(value);

      if (Number.isNaN(number)) {
        return String(value);
      }

      if (Number.isInteger(number)) {
        return String(number);
      }

      return number.toFixed(1).replace(".", ",");
    }

    function getDateKey(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }

      const stringValue = String(value).trim();

      const isoMatch = stringValue.match(/^(\d{4}-\d{2}-\d{2})/);

      if (isoMatch) {
        return isoMatch[1];
      }

      if (/^\d+$/.test(stringValue)) {
        const numericValue = Number(stringValue);

        let timestamp = numericValue;

        if (numericValue < 100000000000) {
          timestamp = numericValue * 1000;
        }

        const timestampDate = new Date(timestamp);

        if (!Number.isNaN(timestampDate.getTime())) {
          return (
            timestampDate.getUTCFullYear() +
            "-" +
            String(timestampDate.getUTCMonth() + 1).padStart(2, "0") +
            "-" +
            String(timestampDate.getUTCDate()).padStart(2, "0")
          );
        }
      }

      const timestamp = Date.parse(stringValue);

      if (Number.isNaN(timestamp)) {
        return null;
      }

      const date = new Date(timestamp);

      return (
        date.getUTCFullYear() +
        "-" +
        String(date.getUTCMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getUTCDate()).padStart(2, "0")
      );
    }

    function dateTimestamp(value) {
      const key = getDateKey(value);

      if (!key) {
        return 0;
      }

      const timestamp = Date.parse(key + "T00:00:00Z");

      return Number.isNaN(timestamp) ? 0 : timestamp;
    }

    function formatDate(value) {
      const key = getDateKey(value);

      if (!key) {
        return "";
      }

      const date = new Date(key + "T00:00:00Z");

      if (Number.isNaN(date.getTime())) {
        return "";
      }

      return new Intl.DateTimeFormat("sv-SE", {
        day: "numeric",
        month: "short",
        year: "numeric",
      }).format(date);
    }

    function formatAxisDate(value) {
      const key = getDateKey(value);

      if (!key) {
        return "";
      }

      const date = new Date(key + "T00:00:00Z");

      if (Number.isNaN(date.getTime())) {
        return "";
      }

      return new Intl.DateTimeFormat("sv-SE", {
        day: "numeric",
        month: "short",
      }).format(date);
    }

    function translateIntentName(name) {
      const value = String(name || "").trim();

      const map = {
        commercial: "Kommersiell",
        informational: "Informationssökning",
        navigational: "Navigationssökning",
        transactional: "Transaktionell",
      };

      return map[value.toLowerCase()] || value;
    }

    function isSerpDataset(dataset) {
      return dataset && dataset.type === "serp-function";
    }

    function isSerpSelection(item) {
      return item && item.type === "serp-function";
    }

    function hasSerpSelection() {
      return selectedItems.some(isSerpSelection);
    }

    /* -------------------------------------------------------
       Status dots
    ------------------------------------------------------- */

    function updateStatusDots() {
      report
        .querySelectorAll(".nsr-report3-status-dot")
        .forEach(function (dot) {
          const value = Number(dot.dataset.value || 0);

          dot.classList.remove("is-green", "is-yellow", "is-red");

          if (value < 20) {
            dot.classList.add("is-green");
          } else if (value < 30) {
            dot.classList.add("is-yellow");
          } else {
            dot.classList.add("is-red");
          }
        });
    }

    /* -------------------------------------------------------
       Score
    ------------------------------------------------------- */

    function updateScoreZone(value) {
      if (!scoreElement) {
        return;
      }

      const number = Number(value);

      scoreElement.classList.remove(
        "is-score-calm",
        "is-score-normal",
        "is-score-high",
        "is-score-very-high",
      );

      if (number >= 30) {
        scoreElement.classList.add("is-score-very-high");
      } else if (number >= 20) {
        scoreElement.classList.add("is-score-high");
      } else if (number >= 10) {
        scoreElement.classList.add("is-score-normal");
      } else {
        scoreElement.classList.add("is-score-calm");
      }
    }

    function getZone(value) {
      const number = Number(value);

      if (number >= 30) {
        return "very-high";
      }

      if (number >= 20) {
        return "high";
      }

      if (number >= 10) {
        return "normal";
      }

      return "calm";
    }

    function getZoneName(value) {
      const zone = getZone(value);

      const names = {
        calm: "Lugn",
        normal: "Normal",
        high: "Hög",
        "very-high": "Mycket hög",
      };

      return names[zone] || "";
    }

    function getZoneSentence(value) {
      const zone = getZone(value);

      const sentences = {
        calm: "Google ligger stilla.",
        normal: "Vanlig rörelse i resultaten.",
        high: "Tydlig rörelse – kolla dina positioner.",
        "very-high": "Kraftig rörelse, troligen en uppdatering.",
      };

      return sentences[zone] || "";
    }

    function getTooltipBand(value) {
      const number = Number(value);

      if (number >= 30) {
        return "Mycket hög";
      }

      if (number >= 20) {
        return "Hög";
      }

      if (number >= 10) {
        return "Normal";
      }

      return "Lugn";
    }

    function getTooltipColorClass(value) {
      const number = Number(value);

      if (number >= 30) {
        return "is-red";
      }

      if (number >= 20) {
        return "is-yellow";
      }

      if (number >= 10) {
        return "is-green";
      }

      return "is-blue";
    }

    /* -------------------------------------------------------
       API
    ------------------------------------------------------- */

    async function getVolatility(type, id = null, days = currentDays) {
      let requestType = type;

      /*
       * Whole market always uses Sweden movement.
       */
      if (id === null || id === undefined || id === "") {
        requestType = "sweden";
      }

      let url =
        "/wp-json/nsr-blocks/v1/volatility/" + encodeURIComponent(requestType);

      if (id !== null && id !== undefined && id !== "") {
        url += "/" + encodeURIComponent(id);
      }

      url += "?days=" + encodeURIComponent(days) + "&_ts=" + Date.now();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Cache-Control": "no-cache",
        },
        cache: "no-store",
      });

      const text = await response.text();

      let data;

      try {
        data = JSON.parse(text);
      } catch (error) {
        throw new Error("Invalid JSON response from WordPress.");
      }

      if (!response.ok) {
        throw new Error(data?.message || data?.code || "Request failed.");
      }

      return data;
    }

    /* -------------------------------------------------------
       Extract API array
    ------------------------------------------------------- */

    function extractApiArray(response) {
      if (Array.isArray(response)) {
        return response;
      }

      if (response && Array.isArray(response.data)) {
        return response.data;
      }

      if (response && Array.isArray(response.results)) {
        return response.results;
      }

      if (response && Array.isArray(response.items)) {
        return response.items;
      }

      if (response && response.data && typeof response.data === "object") {
        if (Array.isArray(response.data.items)) {
          return response.data.items;
        }

        if (Array.isArray(response.data.results)) {
          return response.data.results;
        }

        if (Array.isArray(response.data.data)) {
          return response.data.data;
        }
      }

      return [];
    }

    /* -------------------------------------------------------
       Normalize API data
    ------------------------------------------------------- */

    function normalizeGraphData(response) {
      const raw = extractApiArray(response);

      const points = raw
        .map(function (item) {
          if (!item || typeof item !== "object") {
            return null;
          }

          const rawDate =
            item.date ??
            item.day ??
            item.dateValue ??
            item.measurementDate ??
            item.recordDate ??
            item.timestamp ??
            item.label ??
            item.createdAt ??
            item.created_at;

          const rawValue =
            item.score ??
            item.value ??
            item.movement ??
            item.volatility ??
            item.presencePercentage ??
            item.serpFunctionPercentage ??
            item.percentage;

          const value = Number(rawValue);

          const dateKey = getDateKey(rawDate);

          if (!dateKey || Number.isNaN(value)) {
            return null;
          }

          return {
            label: rawDate,
            dateKey: dateKey,
            timestamp: dateTimestamp(rawDate),
            value: Math.max(0, Math.min(100, value)),
          };
        })
        .filter(Boolean);

      points.sort(function (a, b) {
        return a.timestamp - b.timestamp;
      });

      const map = new Map();

      points.forEach(function (point) {
        map.set(point.dateKey, point);
      });

      return Array.from(map.values()).sort(function (a, b) {
        return a.timestamp - b.timestamp;
      });
    }

    /* -------------------------------------------------------
       Latest point
    ------------------------------------------------------- */

    function getLatestPoint(dataset) {
      if (!dataset || !Array.isArray(dataset.data)) {
        return null;
      }

      for (let i = dataset.data.length - 1; i >= 0; i--) {
        if (dataset.data[i] && dataset.data[i].value !== null) {
          return dataset.data[i];
        }
      }

      return null;
    }

    function getPreviousPoint(dataset) {
      if (!dataset || !Array.isArray(dataset.data)) {
        return null;
      }

      const points = dataset.data.filter(function (point) {
        return point && point.value !== null;
      });

      if (points.length < 2) {
        return null;
      }

      return points[points.length - 2];
    }

    /* -------------------------------------------------------
       Chart dimensions
    ------------------------------------------------------- */

    function getChartDimensions(container, defaultHeight) {
      const rect = container.getBoundingClientRect();

      const width = Math.max(
        320,
        Math.round(rect.width || container.clientWidth || 900),
      );

      let height = defaultHeight;

      if (width < 600) {
        height = Math.max(300, Math.round(width * 0.62));
      }

      return {
        width: width,
        height: height,
      };
    }

    /* -------------------------------------------------------
       X scale for line / axis
    ------------------------------------------------------- */

    function createScale(labels, padding, graphWidth, bandScale) {
      if (!labels.length) {
        return {
          getX: function () {
            return padding.left;
          },
        };
      }

      function getX(point) {
        const index = labels.findIndex(function (label) {
          return label.dateKey === point.dateKey;
        });

        if (index === -1) {
          return padding.left;
        }

        if (bandScale) {
          const slotWidth = graphWidth / labels.length;

          return padding.left + (index + 0.5) * slotWidth;
        }

        if (labels.length === 1) {
          return padding.left + graphWidth / 2;
        }

        return padding.left + (index / (labels.length - 1)) * graphWidth;
      }

      return {
        getX: getX,
      };
    }

    /* -------------------------------------------------------
       Common labels
    ------------------------------------------------------- */

    function buildCommonLabels(datasets) {
      const dateMap = new Map();

      datasets.forEach(function (dataset) {
        dataset.data.forEach(function (point) {
          if (!dateMap.has(point.dateKey)) {
            dateMap.set(point.dateKey, point);
          }
        });
      });

      return Array.from(dateMap.values()).sort(function (a, b) {
        return a.timestamp - b.timestamp;
      });
    }

    function normalizeDatasets(datasets, labels) {
      return datasets.map(function (dataset) {
        const values = new Map();

        dataset.data.forEach(function (point) {
          values.set(point.dateKey, point.value);
        });

        return {
          ...dataset,

          data: labels.map(function (label) {
            return {
              label: label.label,
              dateKey: label.dateKey,
              timestamp: label.timestamp,

              value: values.has(label.dateKey)
                ? values.get(label.dateKey)
                : null,
            };
          }),
        };
      });
    }

    /* -------------------------------------------------------
       Main chart
    ------------------------------------------------------- */

    function renderVolatilityChart(container, datasets) {
      if (!container) {
        return;
      }

      currentMainDatasets = datasets || [];

      const validDatasets = datasets.filter(function (dataset) {
        return (
          dataset &&
          Array.isArray(dataset.data) &&
          dataset.data.some(function (point) {
            return point && point.value !== null;
          })
        );
      });

      if (!validDatasets.length) {
        container.innerHTML =
          '<div class="nsr-report3-empty">Ingen grafdata tillgänglig.</div>';

        return;
      }

      /*
       * SERP and volatility must never
       * share the same axis.
       */
      const serpMode = validDatasets.every(isSerpDataset);

      const volatilityMode = validDatasets.every(function (dataset) {
        return !isSerpDataset(dataset);
      });

      /*
       * Safety fallback.
       *
       * Selection logic prevents this,
       * but never render mixed units.
       */
      if (!serpMode && !volatilityMode) {
        container.innerHTML =
          '<div class="nsr-report3-error">SERP features och volatilitet kan inte visas på samma diagram.</div>';

        return;
      }

      const dimensions = getChartDimensions(container, 350);

      const width = dimensions.width;

      const height = dimensions.height;

      const padding = {
        top: 32,
        right: 24,
        bottom: 64,
        left: width < 600 ? 46 : 58,
      };

      const graphWidth = width - padding.left - padding.right;

      const graphHeight = height - padding.top - padding.bottom;

      const labels = buildCommonLabels(validDatasets);

      const normalizedDatasets = normalizeDatasets(validDatasets, labels);

      const scale = createScale(labels, padding, graphWidth, volatilityMode);

      function getY(value) {
        return padding.top + graphHeight - (Number(value) / 100) * graphHeight;
      }

      const bottom = getY(0);

      let svg = `
        <svg
          class="nsr-report3-chart ${
            serpMode ? "nsr-report3-chart-serp" : "nsr-report3-chart-volatility"
          }"
          width="${width}"
          height="${height}"
          viewBox="0 0 ${width} ${height}"
          role="img"
          aria-label="${
            serpMode ? "SERP-funktionsdiagram" : "Volatilitetsdiagram"
          }"
        >
      `;

      /* ---------------------------------------------------
         Volatility zones
      --------------------------------------------------- */

      if (volatilityMode) {
        const zones = [
          {
            from: 0,
            to: 10,
            className: "zone-calm",
          },
          {
            from: 10,
            to: 20,
            className: "zone-normal",
          },
          {
            from: 20,
            to: 30,
            className: "zone-high",
          },
          /*
           * Requirement:
           * very-high tint should not cover
           * 50–100.
           */
          {
            from: 30,
            to: 50,
            className: "zone-very-high",
          },
        ];

        zones.forEach(function (zone) {
          const yTop = getY(zone.to);

          const yBottom = getY(zone.from);

          svg += `
            <rect
              x="${padding.left}"
              y="${yTop}"
              width="${graphWidth}"
              height="${yBottom - yTop}"
              class="nsr-report3-${zone.className}"
            />
          `;
        });
      }

      /* ---------------------------------------------------
         Grid
      --------------------------------------------------- */

      for (let value = 0; value <= 100; value += 20) {
        const y = getY(value);

        svg += `
          <line
            x1="${padding.left}"
            y1="${y}"
            x2="${width - padding.right}"
            y2="${y}"
            class="nsr-report3-grid-line"
          />

          <text
            x="${padding.left - 10}"
            y="${y + 5}"
            text-anchor="end"
            class="nsr-report3-axis-label"
          >
            ${value}${serpMode ? "%" : ""}
          </text>
        `;
      }

      /* ---------------------------------------------------
         SERP LINE CHART
      --------------------------------------------------- */

      if (serpMode) {
        normalizedDatasets.forEach(function (dataset, datasetIndex) {
          const points = dataset.data.filter(function (point) {
            return point && point.value !== null;
          });

          if (!points.length) {
            return;
          }

          let path = "";

          points.forEach(function (point, pointIndex) {
            const x = scale.getX(point);

            const y = getY(point.value);

            path += pointIndex === 0 ? `M ${x} ${y}` : ` L ${x} ${y}`;
          });

          svg += `
              <path
                d="${path}"
                class="
                  nsr-report3-serp-line
                  nsr-report3-serp-line-${datasetIndex}
                "
                fill="none"
              />
            `;

          /*
           * Requirement 13:
           *
           * <=31:
           * draw circle on every point.
           *
           * >31:
           * only last point.
           *
           * Hover dot is handled by crosshair.
           */
          points.forEach(function (point, pointIndex) {
            const showMarker =
              points.length <= 31 || pointIndex === points.length - 1;

            if (!showMarker) {
              return;
            }

            const x = scale.getX(point);

            const y = getY(point.value);

            svg += `
                  <circle
                    cx="${x}"
                    cy="${y}"
                    r="3.5"
                    class="
                      nsr-report3-serp-marker
                      nsr-report3-serp-marker-${datasetIndex}
                    "
                  />
                `;
          });
        });
      }

      /* ---------------------------------------------------
         Volatility bars
      --------------------------------------------------- */

      if (volatilityMode) {
        const datasetCount = normalizedDatasets.length;

        /*
         * REAL BAND SCALE.
         *
         * Bars are centered inside each
         * category instead of being centered
         * on the plot edges.
         */
        const slotWidth = labels.length
          ? graphWidth / labels.length
          : graphWidth;

        const gap =
          datasetCount === 1
            ? Math.min(6, slotWidth * 0.18)
            : Math.min(5, slotWidth * 0.12);

        const availableBarWidth = Math.max(2, slotWidth - gap);

        const barWidth =
          datasetCount === 1
            ? availableBarWidth
            : Math.max(2, Math.min(18, availableBarWidth / datasetCount));

        normalizedDatasets.forEach(function (dataset, datasetIndex) {
          dataset.data.forEach(function (point, pointIndex) {
            if (point.value === null) {
              return;
            }

            /*
             * Band center:
             *
             * left + (i + 0.5) * width / n
             */
            const slotCenter = padding.left + (pointIndex + 0.5) * slotWidth;

            const totalWidth = barWidth * datasetCount;

            let x = slotCenter - totalWidth / 2 + datasetIndex * barWidth;

            /*
             * Keep every bar fully inside
             * the plot.
             */
            x = Math.max(
              padding.left,
              Math.min(width - padding.right - barWidth, x),
            );

            const y = getY(point.value);

            const barHeight = Math.max(1, bottom - y);

            const barZone =
              point.value >= 30
                ? "very-high"
                : point.value >= 20
                ? "high"
                : "market";

            svg += `
                  <g
                    class="nsr-report3-bar-group"
                  >
                    <rect
                      x="${x}"
                      y="${y}"
                      width="${Math.max(1, barWidth - 1)}"
                      height="${barHeight}"
                      rx="2"
                      class="
                        nsr-report3-bar
                        nsr-report3-bar-${datasetIndex}
                        nsr-report3-${barZone}
                      "
                    />
                `;

            if (point.value >= 20) {
              const markerY = Math.max(padding.top + 7, y - 8);

              const markerX = x + barWidth / 2;

              svg += `
                    <polygon
                      points="
                        ${markerX},${markerY - 3}
                        ${markerX + 3},${markerY + 3}
                        ${markerX - 3},${markerY + 3}
                      "
                      class="
                        nsr-report3-bar-marker
                        ${
                          point.value >= 30
                            ? "nsr-report3-bar-marker-very-high"
                            : "nsr-report3-bar-marker-high"
                        }
                      "
                    />
                  `;
            }

            svg += `
                  </g>
                `;
          });
        });
      }

      /* ---------------------------------------------------
         X axis
      --------------------------------------------------- */

      const maxLabels = 7;

      const labelStep =
        labels.length <= maxLabels
          ? 1
          : Math.ceil((labels.length - 1) / (maxLabels - 1));

      let lastLabelX = -Infinity;

      const minLabelGap = 58;

      labels.forEach(function (point, index) {
        if (index % labelStep !== 0 && index !== labels.length - 1) {
          return;
        }

        let x = scale.getX(point);

        x = Math.max(padding.left, Math.min(width - padding.right, x));

        if (x - lastLabelX < minLabelGap) {
          return;
        }

        svg += `
          <text
            x="${x}"
            y="${height - 20}"
            text-anchor="middle"
            class="nsr-report3-axis-label"
          >
            ${escapeHtml(formatAxisDate(point.label))}
          </text>
        `;

        lastLabelX = x;
      });

      /* ---------------------------------------------------
         Crosshair
      --------------------------------------------------- */

      svg += `
        <g class="nsr-report3-crosshair">
          <line
            class="nsr-report3-crosshair-line"
            x1="${padding.left}"
            y1="${padding.top}"
            x2="${padding.left}"
            y2="${bottom}"
          />

          ${
            serpMode
              ? `
                <circle
                  class="nsr-report3-crosshair-dot"
                  cx="${padding.left}"
                  cy="${bottom}"
                  r="4"
                />
              `
              : ""
          }
        </g>
      `;

      svg += "</svg>";

      container.innerHTML = `
        <div class="nsr-report3-chart-wrapper">
          ${svg}

          <div class="nsr-report3-tooltip"></div>
        </div>

        ${renderLegend(normalizedDatasets, serpMode)}

        ${renderRangeNotes(normalizedDatasets, serpMode)}
      `;

      attachChartInteraction(
        container.querySelector(".nsr-report3-chart-wrapper"),
        container.querySelector(".nsr-report3-chart"),
        normalizedDatasets,
        padding,
        graphHeight,
        bottom,
        serpMode,
      );

      updateMainReadout(normalizedDatasets, serpMode);

      renderDataTable();
    }

    /* -------------------------------------------------------
       Legend
    ------------------------------------------------------- */

    function renderLegend(datasets, serpMode) {
      return `
        <div class="nsr-report3-legend">

          ${datasets
            .map(function (dataset, index) {
              return `
                <div class="nsr-report3-legend-item">
                  <span
                    class="
                      nsr-report3-legend-marker
                      nsr-report3-marker-${index}
                    "
                  ></span>

                  <span>
                    ${escapeHtml(dataset.name)}
                  </span>
                </div>
              `;
            })
            .join("")}

          ${
            serpMode
              ? ""
              : `
                <div class="nsr-report3-zone-legend">

                  <span class="high">
                    <span></span>
                    Hög (20–29)
                  </span>

                  <span class="very-high">
                    <span></span>
                    Mycket hög (30+)
                  </span>

                </div>
              `
          }

        </div>
      `;
    }

    /* -------------------------------------------------------
       Range notes
    ------------------------------------------------------- */

    function renderRangeNotes(datasets, serpMode) {
      if (!datasets.length) {
        return "";
      }

      return `
        <div class="nsr-report3-range-notes">
          ${datasets
            .map(function (dataset) {
              const points = dataset.data.filter(function (point) {
                return point && point.value !== null;
              });

              if (!points.length) {
                return "";
              }

              const first = points[0];

              const last = points[points.length - 1];

              // return `
              //   <div class="nsr-report3-range-note">
              //     <span>
              //       ${escapeHtml(dataset.name)}
              //     </span>

              //     <span>
              //       ${escapeHtml(formatDate(first.label))}
              //       –
              //       ${escapeHtml(formatDate(last.label))}
              //     </span>
              //   </div>
              // `;
            })
            .join("")}
        </div>
      `;
    }

    /* -------------------------------------------------------
       Main readout
    ------------------------------------------------------- */

    function updateMainReadout(datasets, serpMode) {
      if (!datasets.length) {
        return;
      }

      /*
       * Use the active series.
       *
       * When multiple series are selected,
       * use the first selected series as the
       * primary readout.
       */
      const dataset = datasets[0];

      const latest = getLatestPoint(dataset);

      const previous = getPreviousPoint(dataset);

      if (!latest) {
        if (scoreElement) {
          scoreElement.textContent = "—";
        }

        return;
      }

      if (scoreElement) {
        scoreElement.textContent = formatNumber(latest.value);

        if (serpMode) {
          scoreElement.classList.remove(
            "is-score-calm",
            "is-score-normal",
            "is-score-high",
            "is-score-very-high",
          );
        } else {
          updateScoreZone(latest.value);
        }
      }

      /*
       * Unit
       */
      let unitElement = report.querySelector(".nsr-report3-score-unit");

      if (!unitElement && scoreElement) {
        unitElement = document.createElement("span");

        unitElement.className = "nsr-report3-score-unit";

        scoreElement.parentNode.appendChild(unitElement);
      }

      if (unitElement) {
        unitElement.textContent = serpMode ? "%" : "/100";
      }

      /*
       * Zone
       */
      let zoneElement = report.querySelector(".nsr-report3-score-zone");

      if (!zoneElement && scoreElement) {
        zoneElement = document.createElement("span");

        zoneElement.className = "nsr-report3-score-zone";

        scoreElement.parentNode.appendChild(zoneElement);
      }

      if (zoneElement) {
        zoneElement.textContent = serpMode ? "" : getZoneName(latest.value);

        zoneElement.hidden = serpMode;
      }

      /*
       * Heading
       */
      if (titleElement) {
        titleElement.textContent = selectedItems.length
          ? selectedItems
              .map(function (item) {
                return item.name;
              })
              .join(" + ")
          : "Hela marknaden";
      }

      const mainMeta = report.querySelector(".nsr-report3-main-meta");

      if (mainMeta) {
        mainMeta.innerHTML = serpMode
          ? "Andel<br>sökresultat där funktionen visas"
          : "Volatilitetsindex";
      }

      /*
       * Readout sentence
       */
      let readoutMeta = report.querySelector(".nsr-report3-score-meta");

      if (!readoutMeta && scoreElement) {
        readoutMeta = document.createElement("div");

        readoutMeta.className = "nsr-report3-score-meta";

        const parent = scoreElement.parentNode;

        parent.appendChild(readoutMeta);
      }

      if (readoutMeta) {
        let sentence = "";

        if (previous) {
          const diff = Number(latest.value) - Number(previous.value);

          if (diff > 0) {
            sentence = `${dataset.name} den ${formatDate(
              latest.label,
            )}, upp ${formatNumber(diff)} från igår.`;
          } else if (diff < 0) {
            sentence = `${dataset.name} den ${formatDate(
              latest.label,
            )}, ned ${formatNumber(Math.abs(diff))} från igår.`;
          } else {
            sentence = `${dataset.name} den ${formatDate(
              latest.label,
            )}, oförändrad från igår.`;
          }
        } else {
          sentence = `${dataset.name} den ${formatDate(latest.label)}.`;
        }

        /*
         * Volatility readout gets the
         * reshuffling sentence.
         */
        if (!serpMode) {
          sentence += " " + getZoneSentence(latest.value);
        }

        readoutMeta.textContent = sentence;
      }

      /*
       * Latest-data warning.
       *
       * Show only when the latest point
       * is older than yesterday.
       */
      if (alertBox && alertText) {
        const today = new Date();

        today.setHours(0, 0, 0, 0);

        const yesterday = new Date(today);

        yesterday.setDate(yesterday.getDate() - 1);

        const latestDate = new Date(latest.dateKey + "T00:00:00");

        const isOlderThanYesterday = latestDate < yesterday;

        if (isOlderThanYesterday) {
          alertText.textContent =
            "Senaste tillgängliga data: " + formatDate(latest.label) + ".";

          alertText.hidden = false;
          alertBox.hidden = false;
        } else {
          alertText.textContent = "";

          alertText.hidden = true;
          alertBox.hidden = true;
        }
      }
    }

    /* -------------------------------------------------------
       Tooltip / crosshair
    ------------------------------------------------------- */

    function attachChartInteraction(
      wrapper,
      svg,
      datasets,
      padding,
      graphHeight,
      bottom,
      serpMode,
    ) {
      if (!wrapper || !svg || !datasets.length) {
        return;
      }

      const tooltip = wrapper.querySelector(".nsr-report3-tooltip");

      const crosshair = svg.querySelector(".nsr-report3-crosshair");

      const crosshairLine = svg.querySelector(".nsr-report3-crosshair-line");

      const crosshairDot = svg.querySelector(".nsr-report3-crosshair-dot");

      const labels = buildCommonLabels(datasets);

      const rect = svg.getBoundingClientRect();

      const svgWidth = Number(svg.getAttribute("width"));

      const graphWidth = svgWidth - padding.left - padding.right;

      const scale = createScale(labels, padding, graphWidth, !serpMode);

      function hide() {
        if (tooltip) {
          tooltip.classList.remove("is-visible");
        }

        if (crosshair) {
          crosshair.classList.remove("is-visible");
        }
      }

      function showAt(clientX) {
        const currentRect = svg.getBoundingClientRect();

        if (!currentRect.width) {
          return;
        }

        let localX = clientX - currentRect.left;

        localX = Math.max(0, Math.min(currentRect.width, localX));

        const currentSvgWidth = Number(svg.getAttribute("width"));

        const svgX = (localX / currentRect.width) * currentSvgWidth;

        let nearestPoint = null;

        let nearestDistance = Infinity;

        datasets.forEach(function (dataset) {
          dataset.data.forEach(function (point) {
            if (point.value === null) {
              return;
            }

            const pointX = scale.getX(point);

            const distance = Math.abs(pointX - svgX);

            if (distance < nearestDistance) {
              nearestDistance = distance;

              nearestPoint = point;
            }
          });
        });

        if (!nearestPoint) {
          return;
        }

        let nearestX = scale.getX(nearestPoint);

        nearestX = Math.max(
          padding.left,
          Math.min(currentSvgWidth - padding.right, nearestX),
        );

        if (crosshairLine) {
          crosshairLine.setAttribute("x1", nearestX);

          crosshairLine.setAttribute("x2", nearestX);

          crosshairLine.setAttribute("y1", padding.top);

          crosshairLine.setAttribute("y2", bottom);
        }

        /*
         * SERP hover dot.
         *
         * Position it on the active
         * series point.
         */
        if (serpMode && crosshairDot) {
          const activeY = getLocalY(nearestPoint.value, graphHeight, padding);

          crosshairDot.setAttribute("cx", nearestX);

          crosshairDot.setAttribute("cy", activeY);
        }

        if (crosshair) {
          crosshair.classList.add("is-visible");
        }

        if (!tooltip) {
          return;
        }

        const valuesAtDate = [];

        datasets.forEach(function (dataset) {
          const point = dataset.data.find(function (item) {
            return item.dateKey === nearestPoint.dateKey;
          });

          if (point && point.value !== null) {
            valuesAtDate.push({
              name: dataset.name,
              value: point.value,
              type: dataset.type,
            });
          }
        });

        tooltip.innerHTML = `
          <div class="tt-date">
            ${escapeHtml(formatDate(nearestPoint.label))}
          </div>

          ${valuesAtDate
            .map(function (item) {
              const isSerp = item.type === "serp-function";

              const colorClass = isSerp ? "" : getTooltipColorClass(item.value);

              const band = isSerp ? "" : getTooltipBand(item.value);

              return `
                <div class="tt-row">
                  <span
                    class="tt-key ${colorClass}"
                  ></span>

                  <span class="tt-val">
                    ${escapeHtml(formatNumber(item.value))}${isSerp ? "%" : ""}
                  </span>

                  <span class="tt-name">
                    ${escapeHtml(item.name)}
                  </span>
                </div>

                ${
                  band
                    ? `
                      <div
                        class="tt-band ${colorClass}"
                      >
                        ${escapeHtml(band)}
                      </div>
                    `
                    : ""
                }
              `;
            })
            .join("")}
        `;

        const wrapperRect = wrapper.getBoundingClientRect();

        const tooltipWidth = tooltip.offsetWidth || 170;

        let tooltipLeft = localX + 14;

        if (tooltipLeft + tooltipWidth > wrapperRect.width) {
          tooltipLeft = localX - tooltipWidth - 14;
        }

        tooltipLeft = Math.max(8, tooltipLeft);

        tooltip.style.left = tooltipLeft + "px";

        tooltip.style.top = "12px";

        tooltip.classList.add("is-visible");
      }

      wrapper.addEventListener("pointermove", function (event) {
        showAt(event.clientX);
      });

      wrapper.addEventListener("pointerleave", hide);
    }

    function getLocalY(value, graphHeight, padding) {
      return padding.top + graphHeight - (Number(value) / 100) * graphHeight;
    }

    /* -------------------------------------------------------
       Data table
    ------------------------------------------------------- */

    function renderDataTable() {
      const tableHost = report.querySelector(".nsr-report3-table-host");

      const tableToggle = report.querySelector(".nsr-report3-table-toggle");

      const tableNote = report.querySelector(".nsr-report3-table-note");

      const wasOpen =
        tableToggle && tableToggle.getAttribute("aria-expanded") === "true";

      if (!tableHost) {
        return;
      }

      const datasets = [...(currentMainDatasets || [])].filter(function (
        dataset,
      ) {
        return (
          dataset &&
          Array.isArray(dataset.data) &&
          dataset.data.some(function (point) {
            return point && point.value !== null;
          })
        );
      });

      if (!datasets.length) {
        tableHost.innerHTML = "";

        tableHost.hidden = true;

        if (tableToggle) {
          tableToggle.setAttribute("aria-expanded", "false");
        }

        return;
      }

      const dateMap = new Map();

      datasets.forEach(function (dataset) {
        dataset.data.forEach(function (point) {
          if (!point || point.value === null) {
            return;
          }

          if (!dateMap.has(point.dateKey)) {
            dateMap.set(point.dateKey, point);
          }
        });
      });

      const dates = Array.from(dateMap.values()).sort(function (a, b) {
        return b.timestamp - a.timestamp;
      });

      const columns = datasets.map(function (dataset) {
        return {
          name: dataset.name,

          type: dataset.type,

          data: new Map(
            dataset.data
              .filter(function (point) {
                return point && point.value !== null;
              })
              .map(function (point) {
                return [point.dateKey, point.value];
              }),
          ),
        };
      });

      const caption =
        "Samma värden som i diagrammet, nyaste dagen först. Volatilitet är ett index 0–100, SERP-funktioner anges i procent.";

      let html = `
        <table class="nsr-report3-data-table">
          <caption>
            ${escapeHtml(caption)}
          </caption>

          <thead>
            <tr>
              <th scope="col">
                Datum
              </th>

              ${columns
                .map(function (column) {
                  return `
                    <th scope="col">
                      ${escapeHtml(column.name)}
                    </th>
                  `;
                })
                .join("")}
            </tr>
          </thead>

          <tbody>
      `;

      dates.forEach(function (date) {
        html += `
          <tr>
            <th scope="row">
              ${escapeHtml(formatDate(date.label))}
            </th>
        `;

        columns.forEach(function (column) {
          const value = column.data.get(date.dateKey);

          if (value === undefined || value === null) {
            html += "<td>–</td>";

            return;
          }

          const number = Number(value);

          const isSerp = column.type === "serp-function";

          html += `
              <td>
                ${escapeHtml(formatNumber(number))}${isSerp ? "%" : ""}
              </td>
            `;
        });

        html += `
          </tr>
        `;
      });

      html += `
          </tbody>
        </table>
      `;

      tableHost.innerHTML = html;

      if (tableToggle) {
        tableToggle.setAttribute("aria-expanded", String(wasOpen));

        tableToggle.textContent = wasOpen
          ? "Göm siffrorna"
          : "Visa siffrorna som en tabell";
      }

      tableHost.hidden = !wasOpen;

      if (tableNote && dates.length) {
        const oldest = dates[dates.length - 1];

        const newest = dates[0];

        const isSerp = datasets.every(function (dataset) {
          return dataset.type === "serp-function";
        });

        tableNote.textContent =
          formatDate(oldest.label) +
          " – " +
          formatDate(newest.label) +
          (isSerp ? " · andel i %" : " · scale 0–100");
      }
    }

    /* -------------------------------------------------------
       Main chart update
    ------------------------------------------------------- */

    async function updateMainChart() {
      const thisRequest = ++requestVersion;

      const selections = selectedItems.filter(function (item) {
        return (
          item.type === "industry" ||
          item.type === "search-intent" ||
          item.type === "serp-function"
        );
      });

      if (titleElement) {
        titleElement.textContent = selections.length
          ? selections
              .map(function (item) {
                return item.name;
              })
              .join(" + ")
          : "Hela marknaden";
      }

      volatilityContainer.innerHTML =
        '<div class="nsr-report3-loading">Laddar...</div>';

      try {
        const datasets = [];

        /*
         * Whole market
         */
        if (!selections.length) {
          const response = await getVolatility("sweden", null, currentDays);

          if (thisRequest !== requestVersion) {
            return;
          }

          datasets.push({
            name: "Hela marknaden",
            type: "sweden",
            data: normalizeGraphData(response),
          });
        } else {
          /*
           * TRUE MULTI-SELECT.
           */
          const responses = await Promise.all(
            selections.map(function (item) {
              return getVolatility(item.type, item.id, currentDays);
            }),
          );

          if (thisRequest !== requestVersion) {
            return;
          }

          responses.forEach(function (response, index) {
            const item = selections[index];

            datasets.push({
              name: item.name,
              type: item.type,
              data: normalizeGraphData(response),
            });
          });
        }

        if (thisRequest !== requestVersion) {
          return;
        }

        renderVolatilityChart(volatilityContainer, datasets);
      } catch (error) {
        if (thisRequest !== requestVersion) {
          return;
        }

        volatilityContainer.innerHTML =
          '<div class="nsr-report3-error">' +
          escapeHtml(error.message || "Kunde inte ladda data.") +
          "</div>";
      }
    }

    /* -------------------------------------------------------
       Selection
    ------------------------------------------------------- */

    function clearItemVisualState(item) {
      if (!item) {
        return;
      }

      report
        .querySelectorAll(".nsr-report3-item.is-selected")
        .forEach(function (element) {
          if (
            element.dataset.type === item.type &&
            String(element.dataset.id) === String(item.id)
          ) {
            element.classList.remove("is-selected");
          }
        });
    }

    function clearAllVisualSelection() {
      report
        .querySelectorAll(".nsr-report3-item.is-selected")
        .forEach(function (item) {
          item.classList.remove("is-selected");
        });
    }

    function selectItem(itemElement) {
      const type = itemElement.dataset.type || "";

      const id = itemElement.dataset.id || "";

      let name =
        itemElement.dataset.name ||
        itemElement
          .querySelector(".nsr-report3-item-name")
          ?.textContent.trim() ||
        "";

      if (type === "search-intent") {
        name = translateIntentName(name);
      }

      /*
       * Same item:
       * toggle it off.
       */
      const existingIndex = selectedItems.findIndex(function (item) {
        return item.type === type && String(item.id) === String(id);
      });

      if (existingIndex !== -1) {
        const removed = selectedItems.splice(existingIndex, 1)[0];

        clearItemVisualState(removed);

        renderSelected();

        updateGraphs();

        return;
      }

      const selectingSerp = type === "serp-function";

      /*
       * SERP replaces volatility.
       *
       * Requirement 12:
       * never put both units on one axis.
       */
      selectedItems.forEach(function (item) {
        clearItemVisualState(item);
      });

      selectedItems = [];

      /*
       * REAL MULTI-SELECT.
       *
       * No same-type replacement.
       * No maximum of two.
       */
      selectedItems.push({
        type: type,
        id: id,
        name: name,
      });

      itemElement.classList.add("is-selected");

      renderSelected();

      updateGraphs();
    }

    /* -------------------------------------------------------
       Selected chips
    ------------------------------------------------------- */

    function renderSelected() {
      if (!selectedContainer) {
        return;
      }

      if (!selectedItems.length) {
        selectedContainer.innerHTML =
          '<span class="nsr-report3-no-selection">Inget valt</span>';

        return;
      }

      selectedContainer.innerHTML = selectedItems
        .map(function (item) {
          return `
              <button
                type="button"
                class="nsr-report3-selected-chip"
                data-type="${escapeHtml(item.type)}"
                data-id="${escapeHtml(item.id)}"
              >
                <span>
                  ${escapeHtml(item.name)}
                </span>

                <span class="nsr-report3-chip-remove">
                  ×
                </span>
              </button>
            `;
        })
        .join("");

      selectedContainer
        .querySelectorAll(".nsr-report3-selected-chip")
        .forEach(function (chip) {
          chip.addEventListener("click", function () {
            const type = chip.dataset.type;

            const id = chip.dataset.id;

            const index = selectedItems.findIndex(function (item) {
              return item.type === type && String(item.id) === String(id);
            });

            if (index !== -1) {
              selectedItems.splice(index, 1);
            }

            clearAllVisualSelection();

            selectedItems.forEach(function (item) {
              const selector = `.nsr-report3-item[data-type="${CSS.escape(
                item.type,
              )}"][data-id="${CSS.escape(String(item.id))}"]`;

              const element = report.querySelector(selector);

              if (element) {
                element.classList.add("is-selected");
              }
            });

            renderSelected();

            updateGraphs();
          });
        });
    }

    /* -------------------------------------------------------
       Graph update
    ------------------------------------------------------- */

    async function updateGraphs() {
      requestVersion++;

      await updateMainChart();
    }

    /* -------------------------------------------------------
       Item click
    ------------------------------------------------------- */

    report.querySelectorAll(".nsr-report3-item").forEach(function (item) {
      item.addEventListener("click", function () {
        selectItem(item);
        if (window.innerWidth <= 768) {
          const chart = report.querySelector(".nsr-report3-main");

          if (chart) {
            chart.scrollIntoView({
              block: "start",
              behavior: "smooth",
            });
          }
        }
      });
    });

    /* -------------------------------------------------------
       Tabs
    ------------------------------------------------------- */

    report.querySelectorAll(".nsr-report3-tab").forEach(function (tab) {
      tab.addEventListener("click", function () {
        const target = tab.dataset.tab;

        report.querySelectorAll(".nsr-report3-tab").forEach(function (button) {
          button.classList.toggle("is-active", button === tab);
        });

        report.querySelectorAll(".nsr-report3-list").forEach(function (list) {
          list.classList.toggle("is-active", list.dataset.list === target);
        });

        filterItems();
      });
    });

    /* -------------------------------------------------------
       Search
    ------------------------------------------------------- */

    function filterItems() {
      const query = (searchInput?.value || "").trim().toLowerCase();

      const activeList = report.querySelector(".nsr-report3-list.is-active");

      if (!activeList) {
        return;
      }

      activeList.querySelectorAll(".nsr-report3-item").forEach(function (item) {
        const name = (
          item.dataset.name ||
          item.querySelector(".nsr-report3-item-name")?.textContent ||
          ""
        ).toLowerCase();

        item.style.display = !query || name.includes(query) ? "" : "none";
      });
    }

    if (searchInput) {
      searchInput.addEventListener("input", filterItems);
    }

    /* -------------------------------------------------------
       Clear selections
    ------------------------------------------------------- */

    const clearButton = report.querySelector(".nsr-report3-clear");

    if (clearButton) {
      clearButton.addEventListener("click", function () {
        selectedItems = [];

        clearAllVisualSelection();

        renderSelected();

        updateGraphs();
      });
    }

    /* -------------------------------------------------------
       Periods
    ------------------------------------------------------- */

    report.querySelectorAll(".nsr-report3-period").forEach(function (button) {
      button.addEventListener("click", function () {
        const days = parseInt(button.dataset.days, 10);

        if (!days || days <= 0) {
          return;
        }

        currentDays = days;

        report.querySelectorAll(".nsr-report3-period").forEach(function (item) {
          item.classList.toggle("is-active", item === button);
        });

        updateGraphs();
      });
    });

    /* -------------------------------------------------------
       Responsive redraw
    ------------------------------------------------------- */

    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(function () {
        if (currentMainDatasets.length) {
          renderVolatilityChart(volatilityContainer, currentMainDatasets);
        }
      }, 150);
    });

    /* -------------------------------------------------------
       Initial state
    ------------------------------------------------------- */

    renderSelected();

    updateStatusDots();

    updateGraphs();
  }
});
